module.exports = "/fonts/Ki.eot?31f3692ca10d2f6d0bc467adba4533f7";